































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { IEditButtonCellRendererParams } from "../table";

@Component
export default class GridEditButton extends Vue {
    /**
     * Row parameter data
     * https://www.ag-grid.com/vue-data-grid/component-cell-renderer/#cell-renderer-component-3
     */
    params!: IEditButtonCellRendererParams;

    get id(): number {
        return this.params.value as number;
    }

    modalOpen = false;

    editClicked() {
        // Redirect OR open a modal

        if (this.params.routeName) {
            this.$router.push({
                name: this.params.routeName,
                params: { id: this.id.toString() }
            });
            return;
        }

        this.modalOpen = true;
    }

    @Watch("addModalOpen")
    modalChanged() {
        if (!this.modalOpen && this.params.eventName) {
            this.$root.$emit(this.params.eventName);
        }
    }
}
